import React, { useState } from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { useFormatDate  } from 'hooks';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import {Button, Col, OverlayTrigger, Tooltip, Form, Row} from 'react-bootstrap'; 
import logoAirbnb from 'assets/img/logos/airbnb_logo.png';
import logoexpedia from 'assets/img/logos/expedia.png';
import logoabritel from 'assets/img/logos/abritel.png';
import logodirect from 'assets/img/logoIcon.png';
import tripadvisor from 'assets/img/logos/tripadvisor.jpg';
import locasun from 'assets/img/logos/locasun.png';
import homeToGo from 'assets/img/logos/homeToGo.jpeg'
import kayak from 'assets/img/logos/kayak.webp'
import homerez from 'assets/img/logos/homerez.png'
import booking from 'assets/img/logos/booking.png'
import { makeCsv, getTableDataForExport , getColKeyArrayObject} from 'state/actions/users';

const Entreesortie = () => {

    const [clients, setClients] = React.useState([]);
  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]);   
  const [colexport, setColExport] = React.useState([]);

  const isProchainJour = (date) => {

    var aujourdhui = new Date();

    // Calculez la date dans 7 jours
    var dateDans7Jours = new Date();
    dateDans7Jours.setDate(aujourdhui.getDate() + 7);

    // Fonction pour vérifier si une date est comprise dans les 7 prochains jours
    function estDansLes7ProchainsJours(date) {
        return date >= aujourdhui && date <= dateDans7Jours;
    }
    return estDansLes7ProchainsJours(date)
  }




  const logo = (l) => {
     
    switch (l?.value) {
      case "booking":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={booking}
              alt={l}
              width={50}  
            />
      </OverlayTrigger>  
      case "homerez":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={homerez}
              alt={l}
              width={50}  
            />
      </OverlayTrigger>  
      case "kayak":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={kayak}
              alt={l}
              width={50}  
            />
      </OverlayTrigger>  
      case "homeToGo":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={homeToGo}
              alt={l}
              width={50}  
            />
      </OverlayTrigger>  
      case "locasun":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={locasun}
              alt={l}
              width={50}  
            />
      </OverlayTrigger> 
      case "tripadvisor":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={tripadvisor}
              alt={l}
              width={50}  
            />
      </OverlayTrigger> 
      case "direct":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={logodirect}
              alt={l}
              width={50}  
            />
      </OverlayTrigger> 
      case "abritel":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={logoabritel}
              alt={l}
              width={50}  
            />
      </OverlayTrigger> 
      case "airbnb":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={logoAirbnb}
              alt={l}
              width={30}  
            />
      </OverlayTrigger> 
      case "expedia":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
        src={logoexpedia}
        alt={l}
        width={30}  
      />
      </OverlayTrigger> 
    
      default:
        return <span>{l?.label}</span>;
    }
  }

  const loadBooking = (cl) => {
    setL(true); 
    firebase.firestore().collection('bookings').get().then((snap)=> {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        l.id = d.id;
        if (l?.delete){
          // supprimer donc ne pas affiché
        }else{
            if (l.statut.value === "confirmed"){
                l.villa = l.property.label 
                cl?.forEach((c) => {
                    if (c.value === l.client?.value){ 
                        l.cl = c.data;
                    }
                })
                if (isProchainJour(l?.checkin?.toDate())){
                    s.push(l)
                }
                
            }
          
        }
        
      })
      console.log("s" ,s)
      setData(s);

      setColExport(getColKeyArrayObject(s));
      setL(false); 
    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  
   

  const columns = [
    {
      accessor: 'origin',
      Header: 'Origine',
      headerProps: { className: 'text-900' }, 
      Cell: ({ row }) => (
        <div style={{display: "flex",
          alignItems: "center",
          justifyContent: "center"}}>
          {logo(row.original?.origin)} 
        </div>
      )
    },  
    {
      accessor: 'villa',
      Header: 'Villa',
      headerProps: { className: 'text-900' }, 
      Cell: ({ row }) => (
      <>
        <span>{row.original.villa}</span> 
        <br/>
        {row?.original?.checkin && row?.original?.checkin?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
            {useFormatDate(row.original?.checkin?.toDate(), {
                day:'numeric',
                weekday: 'short',
                year: 'numeric',
                month: 'short', 
            })}
            </small> 
        )}
        <br/>
        {row?.original?.checkout && row?.original?.checkout?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
                {useFormatDate(row.original?.checkout?.toDate(), {
                day:'numeric',
                weekday: 'short',
                year: 'numeric',
                month: 'short', 
                })}
            </small> 
        )}
     </>
      )
    },       
   
    {
      accessor: 'client',
      Header: 'Client',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { cl, client } = rowData.row.original
        return <p>
            Client: {cl.lastName} {cl.firstName}<br/>
            Langue: {cl.nationality}<br/>
            Tel: {cl.phone}<br/>
            Email: {client?.email}<br/>
            Préférences: {cl?.preferences?.join(', ') || "Aucun"}
        </p>
      }
    },   
    {
        accessor: 'comment',
        Header: 'Commentaire',
        headerProps: { className: 'text-900' }, 
      },
      {
          accessor: 'total_pay',
          Header: 'Total',
          headerProps: { className: 'text-900' },
          Cell: rowData => {
            const { total_pay } = rowData.row.original
            return <span>{total_pay} €</span>
          }
        },       
  ];

  const getClients = (cb) => {
    // get list clients and format
    firebase.firestore().collection('crm').get().then((snap)=> {
        let s = [];
        snap.forEach((d) => { 
            let e = '';
            let pre = d.data()?.email?.split(',') || []
            pre.forEach((s) =>{
                e += `${s}, `;
            })
          const dr = {value : d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, data: d.data() }
          if (d.data()?.delete){}
          else{
            s.push(dr)
          }
        })
        setClients(s);
        cb(s)
      }).catch((error) => {
        setL(false); 
        var errorMessage = error.message;
        toast.error(errorMessage);
      })

}

  React.useEffect(() => {
    if (data.length === 0){
        getClients((c) => {
            loadBooking(c)
        })
      
    }
  }, []);

// const data = [
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"modérateur"
//   },
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"admin"
//   },
// ];
 
 
 

function AdvanceTableExample() {

  if (l){
    return <p>Chargement...</p>
  }
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={205}
    > 
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
      <div id="orders-actions">
      {/* <IconButton  href="/newbooking"
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">Nouvelle réservation</span>
      </IconButton>  */}

      {/* { data && data.length > 0 && (
              <IconButton 

                variant="falcon-default"
                size="sm"
                icon="file"
                transform="shrink-3"
                className='me-2'
                  onClick={() => makeCsv(getTableDataForExport(data, colexport), `comptabilite-bo-house.csv`)}
  
              >
                Export des données en CSV 
                  </IconButton>)} */}

      <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table/>
        </Col>
    </div>
      </Col>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
} 


    return (
      
      <FalconComponentCard>
      <FalconComponentCard.Header
        title="Entrée Sortie (sur les 7 prochains jours)"
        light={false}
        className="border-bottom border-200" noPreview={true} 
      />
      <FalconComponentCard.Body>
        <AdvanceTableExample />
      </FalconComponentCard.Body>
    </FalconComponentCard>
    );
}

export default Entreesortie;
